(function (root) {
  const rowsFor = (data, make, model) => data.fitments.filter(r => r.make === make && r.models.includes(model));
  function availableYears(data, make, model, currentYear = new Date().getFullYear()) {
    const years = new Set();
    for (const r of rowsFor(data, make, model)) {
      if (!r.start?.year) continue;
      for (let y = r.start.year; y <= Math.min(r.end?.year || currentYear, currentYear); y++) years.add(y);
    }
    return [...years].sort((a,b) => b-a);
  }
  function assess(data, choice) {
    if (!choice.make || !choice.model || !choice.year) return [];
    const year = Number(choice.year);
    return rowsFor(data,choice.make,choice.model).filter(r => choice.year === 'all' ||
      !(r.start?.year > year || r.end?.year < year)).map(r => ({...r,
        boundary: choice.year !== 'all' && [r.start,r.end].some(d => d?.month && d.year === year),
        incomplete: !r.allYears && (!r.start || !r.end)
      }));
  }
  const api = {availableYears,assess};
  if (typeof module !== 'undefined') module.exports = api;
  root.SeatEngine = api;
})(typeof window === 'undefined' ? globalThis : window);
